import { markRaw } from 'vue';

export default {
  namespaced: true,
  state: () => ({
    toasts: [],
  }),
  mutations: {
    ADD_TOAST(state, { component, props, id }) {
      state.toasts.push({
        id,
        component: markRaw(component),
        props,
      });
    },
    REMOVE_TOAST(state, id) {
      state.toasts = state.toasts.filter((t) => t.id !== id);
    },
    CLEAR_TOASTS(state) {
      state.toasts = [];
    },
  },
  actions: {
    addToast(
      { commit, dispatch },
      { component, props, duration = 5000, manuallyClose = false }
    ) {
      const id = Date.now();
      commit('ADD_TOAST', { component, props: { ...props, id } });

      setTimeout(() => {
        if (!manuallyClose) {
          dispatch('clearToasts');
        }
      }, duration);
    },
    removeToast({ commit }, id) {
      commit('REMOVE_TOAST', id);
    },
    clearToasts({ commit }) {
      commit('CLEAR_TOASTS');
    },
  },
};
